// extracted by mini-css-extract-plugin
export default {"mCard":"EE-z","image":"FE-z","imageNoBackground":"GE-z","imageHasCategory":"HE-z","fullWidth":"IE-z"};